export const widgetDefaults = {
  pageName: 'booking_form_widget',
};
